import React from 'react';
import styles from './index.modules.scss';
import { Image, Text } from '@shakkerai/pro-components';
import emptyBg from './assets/bg_empty.svg';

export const Empty = (props) => {
  const { src, content } = props;
  return (
    <div className={styles.empty}>
      <Image src={src || emptyBg} h={110} w={110} className={styles.image} />
      <Text className={styles.content} color="#969696">
        {content}
      </Text>
    </div>
  );
};
